export class ProgramDurationItem {
  public static createEmpty(): ProgramDurationItem {
    return new ProgramDurationItem(1, 0);
  }
  constructor(
    public Hours: number,
    public Minutes: number,
  ) {}
}
